import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from './auth-service.service';
import { BehaviorSubject, catchError, map, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AddressService {
  get _liveApiUrl() {
    return this.authService._liveApiUrl;
  }
  constructor(private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private toastr: ToastrService,
    public authService: AuthServiceService) { }
  private _address = new BehaviorSubject<object[]>([]);
  private addressData: { address: object[] } = { address: [] };
  addressAdd(form: any): Observable<any> {
    return this.http
      .post<any>(`${this._liveApiUrl}/company/add-address/`, form)
      .pipe(
        map((data: any) => {
          // 🔹 Check for API error
          if (this.authService.resultCodeError(data)) {
            return throwError(() => data);
          }
          return data;
        }),
        catchError((error) => this.authService.handleError(error))
      );
  }
  addressSearch(page: any, searchVal?: string) {
    let tail = '';
    if (page) {
      tail = `${page}`;
    }
    if (searchVal) {
      tail += "&search_text=" + searchVal;
    }

    this.http
      .get<any>(`${this._liveApiUrl}/company/address-listing/?page=${tail}`)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.authService.handleError)
      )
      .subscribe(
        (data: any) => {
          if (data.errorMessage === 'Invalid page number' && page > 2) {
            localStorage.setItem('addressslistingpageno', (page - 1).toString())
            this.addressSearch(page - 1)
            return
          }

          this.addressData.address = data;
          this._address.next(Object.assign({}, this.addressData).address);
        },
        (error) => {
          this.authService.dataError(error);
        }
      );
  }
  getAddress(): Observable<any[]> {
    return this._address.asObservable();
  }

  addressSearchObservable(page: any = 1, searchVal?: string): Observable<any> {
    let tail = `${page}`;
    if (searchVal) {
      tail += `&search_text=${searchVal}`;
    }
    return this.http.get<any>(`${this._liveApiUrl}/company/address-listing/?page=${tail}`).pipe(
      catchError(this.authService.handleError)
    );
  }
  addressDelete(id: number): Observable<any> {
    return this.http
      .delete<any>(`${this._liveApiUrl}/company/delete-address/${id}`)
      .pipe(
        map((data: any) => {
          // 🔹 Check for API error
          if (this.authService.resultCodeError(data)) {
            return throwError(() => data);
          }
          return data;
        }),
        catchError((error) => this.authService.handleError(error))
      );
  }
  getAddressListing(page: any, searchVal?: string) {

    let tail = '';

    if (page) {
      tail = `${page}`;
    }

    if (searchVal) {
      tail += "&search_text=" + searchVal;
    }

    return this.http.get<any>(
      `${this._liveApiUrl}/company/address-listing/?page=${tail}`
    );
  }

  getAllAddressListing(page?: number, location?: string, searchText?: string, pageSize?: number): Observable<any> {
    let params: string[] = [];
    if (page) {
      params.push(`page=${page}`);
    }

    if (pageSize) {
      params.push(`page_size=${pageSize}`);
    }

    if (location) {
      params.push(`location=${encodeURIComponent(location)}`);
    }
    if (searchText && searchText.trim()) {
      params.push(`search_text=${encodeURIComponent(searchText.trim())}`);
    }
    const queryString = params.length > 0 ? '?' + params.join('&') : '';

    return this.http
      .get<any>(`${this._liveApiUrl}/company/all-address-listing/${queryString}`)
      .pipe(
        map((data: any) => {
          return data.result || data;
        }),
        catchError((error) => this.authService.handleError(error))
      );
  }

}